import React from 'react';
import Fade from 'react-reveal/Fade';
import { InputText } from 'elements/Form';

export default function BookingInformation(props) {
    const { data, ItemDetails, checkout } = props;

    return (
        <Fade>
            <div className="container">

                {/* --- Tampilan DESKTOP --- */}
                <div className="row justify-content-center align-items-center d-none d-md-flex" style={{ marginTop:-50 }}>
                    <div className="col-5 border-right py-5" style={{ paddingRight: 80 }}>
                        <Fade delay={300}>
                            <div className="card" style={{ border: "none"}}>
                                <figure className="img-wrapper" style={{ height: 270, borderRadius: "10px", overflow: "hidden" }}>
                                    <img
                                        src={ItemDetails.imageId[0]
                                            ? `${process.env.REACT_APP_HOST}/images/${ItemDetails.imageId[0].imageUrl}`
                                            : ""}
                                        alt={ItemDetails.title}
                                        className="img-cover"
                                    />
                                </figure>
                                <div className="row align-items-center">
                                    <div className="col">
                                        <div className="meta-wrapper">
                                            <h5>{ItemDetails.title}</h5>
                                            <span className="text-gray-500">
                                                {ItemDetails.city}, {ItemDetails.country}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <span>
                                            Rp. {new Intl.NumberFormat('id-ID').format(checkout.duration * ItemDetails.price)}
                                            <span className="text-gray-500"> per </span>
                                            {checkout.duration} {ItemDetails.unit}
                                            {+checkout.duration > 1 ? "s" : ""}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>

                    <div className="col-5 py-5" style={{ paddingLeft: 80 }}>
                        <Fade delay={600}>
                            <label htmlFor="firstName">First Name</label>
                            <InputText
                                id="firstName"
                                name='firstName'
                                type='text'
                                value={data.firstName}
                                onChange={props.onChange}
                            />

                            <label htmlFor="lastName">Last Name</label>
                            <InputText
                                id="lastName"
                                name='lastName'
                                type='text'
                                value={data.lastName}
                                onChange={props.onChange}
                            />

                            <label htmlFor="email">Email Address</label>
                            <InputText
                                id="email"
                                name='email'
                                type='email'
                                value={data.email}
                                onChange={props.onChange}
                            />

                            <label htmlFor="phone">Phone Number</label>
                            <InputText
                                id="phone"
                                name='phone'
                                type='tel'
                                value={data.phone}
                                onChange={props.onChange}
                            />
                        </Fade>
                    </div>
                </div>

                {/* --- Tampilan MOBILE --- */}
                <div className="d-block d-md-none">
                    <Fade bottom>
                        <div className="card mb-4" style={{ border: "none" }}>
                            <figure className="img-wrapper" style={{ height: 200, borderRadius: "10px", overflow: "hidden" }}>
                                <img
                                    src={ItemDetails.imageId[0]
                                        ? `${process.env.REACT_APP_HOST}/images/${ItemDetails.imageId[0].imageUrl}`
                                        : ""}
                                    alt={ItemDetails.title}
                                    className="w-100 h-100"
                                    style={{ objectFit: "cover", objectPosition: "center" }}
                                />
                            </figure>
                            <div className="text-center p-3">
                                <h5 className="mb-1">{ItemDetails.title}</h5>
                                <p className="text-muted small mb-2">
                                    {ItemDetails.city}, {ItemDetails.country}
                                </p>
                                <p className="fw-semibold">
                                    Rp. {new Intl.NumberFormat('id-ID').format(checkout.duration * ItemDetails.price)}
                                    <span className="text-gray-500"> / </span>
                                    {checkout.duration} {ItemDetails.unit}
                                    {+checkout.duration > 1 ? "s" : ""}
                                </p>
                            </div>
                        </div>

                        <div className="px-2">
                            <label htmlFor="firstName">First Name</label>
                            <InputText
                                id="firstName"
                                name='firstName'
                                type='text'
                                value={data.firstName}
                                onChange={props.onChange}
                            />

                            <label htmlFor="lastName">Last Name</label>
                            <InputText
                                id="lastName"
                                name='lastName'
                                type='text'
                                value={data.lastName}
                                onChange={props.onChange}
                            />

                            <label htmlFor="email">Email Address</label>
                            <InputText
                                id="email"
                                name='email'
                                type='email'
                                value={data.email}
                                onChange={props.onChange}
                            />

                            <label htmlFor="phone">Phone Number</label>
                            <InputText
                                id="phone"
                                name='phone'
                                type='tel'
                                value={data.phone}
                                onChange={props.onChange}
                            />
                        </div>
                    </Fade>
                </div>

            </div>
        </Fade>
    );
}
